import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Wrapper = styled.div<{ start?: boolean; background?: string }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;

  transform: scale(${(props) => (props.start ? '1' : '0')});
  opacity: ${(props) => (props.start ? '1' : '0')};
`;
export const ClickLayer = styled.div<{ start?: boolean; background?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  opacity: ${(props) => (props.start ? '1' : '0')};
`;

export const Container = styled.div<{ disableSelect?: boolean }>`
  max-width: 500px;
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  background: #ebebeb;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  border: 8px solid #ebebeb;
  overflow: hidden;
  margin-top: -var('--regi-nav-height');
  z-index: 2;
  position: relative;  
  -webkit-user-select: ${(props) => (props.disableSelect ? 'none' : 'unset')};
  -ms-user-select: ${(props) => (props.disableSelect ? 'none' : 'unset')};
  user-select: ${(props) => (props.disableSelect ? 'none' : 'unset')};


  ${mq(Devices.mobile)} {
    margin: 0 10px;
  }
`;

export const ContainerBox = styled.div`
  position: absolute;
  top:-80px;
  bottom:-20px;
  left:-20px;
  right:-20px;
  width:calc(100% + 40px);
  height:calc(100% + 100px);
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #ebebeb;
  z-index: 4;
  border-radius: 14px;
  overflow: hidden;
`;

export const PreviewTop = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  background: #fad300;
  border-radius: 8px 8px 0 0;

  span {
    font-size: 20px;
    font-weight: 700;
  }
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: #2a848e;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  svg {
    height: 48%;
    path {
      fill: #fff;
    }
  }

  :hover {
    background: #2a848ecc;
  }
`;

export const PreviewRow = styled.div<{ center?: boolean }>`
  min-height: 50px;
  width: 100%;
  display: flex;
  padding: 10px 20px;
  z-index: 5;
  position: relative;

  span {
    font-size: 18px;
    font-weight: 500;
  }
  span:nth-of-type(2) {
    margin-left: auto;
  }
`;

export const TimerRow = styled.div<{ center?: boolean }>`
  min-height: 50px;
  width: 100%;
  display: flex;
  padding: 0px 20px;
  z-index: 5;
  position: relative;
  justify-items: center;
  justify-content: center;

  div {
    font-size: 32px;
    font-weight: 500;
  }
`;

export const CanvasContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  canvas {
    height: unset !important;
    width: 60% !important;
    aspect-ratio: 1 / 1 !important;
  }
  >div{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    width: 60% !important;
    aspect-ratio: 1 / 1 !important;
  }
`;

export const Background = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  background: #ffe88e;
`;
